module.exports = __webpack_public_path__ + "img/icon-location.0375a391.svg";